/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthenticationError } from "@/data/base_classes/authentication_error";
import { auth } from "@/firebase";

export const isFalsy = (value: unknown): boolean => {
  return (
    value === 0 ||
    value === false ||
    value === "" ||
    value === null ||
    value === undefined
  );
};

// TODO: Create format functions to convert unknowns to correct data types
export const formatStringArray = (value: unknown): string[] | undefined => {
  if (Array.isArray(value)) {
    return value.map((item) => {
      return formatString(item) ?? "";
    });
  }

  if (typeof value === "string") {
    try {
      const parsedValue = JSON.parse(value);
      if (Array.isArray(parsedValue)) {
        return parsedValue.map((item) => {
          return formatString(item) ?? "";
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  return undefined;
};

export const formatDate = (value: unknown): Date | undefined => {
  if (typeof value === "string") {
    return new Date(value);
  } else if (value instanceof Date) {
    return value;
  }

  return undefined;
};

export const formatString = (value: unknown): string | undefined => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    return value.toString();
  }

  return undefined;
};

export const formatBoolean = (value: unknown): boolean | undefined => {
  if (typeof value === "boolean") {
    return value;
  }

  return !isFalsy(value);
};

export const formatNumber = (value: unknown): number | undefined => {
  if (typeof value === "string") {
    if (value.includes(".") || value.includes(",")) {
      return parseFloat(value);
    } else {
      return parseInt(value);
    }
  }
  if (typeof value === "number") {
    return value;
  }

  return undefined;
};

/**
 * Check if a field is validated
 * @param {string} key - The field key
 * @returns {boolean | null} True if the field is validated, false if not, null if not checked
 */
export function isValidated(
  errors: Array<{ field: string }>,
  key: string,
): boolean | null {
  return errors?.find(({ field }) => field === key) === undefined
    ? null
    : false;
}

/**
 * Find the user ID
 * @param {string} userId - The userId to check
 * @returns {string} Returns the userId or fails with an error
 */
export function validateOrGetUserId(userId?: string): string {
  if (isFalsy(userId)) {
    userId = auth.firebaseUser?.uid ?? undefined;
  }
  if (isFalsy(userId)) {
    userId = sessionStorage.getItem("userId") ?? undefined;
  }
  if (userId === "" || userId === undefined) {
    throw new AuthenticationError("No user ID found");
  }

  return userId;
}

/**
 * Check if a route patrh exists
 * @param {string} path - The path to check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function routePathExists(routes: any[], path: string): boolean {
  // Remove query parameters
  const currentPath = path.split("?")[0];

  if (currentPath.includes("sign_out")) {
    return true;
  }

  if (
    currentPath.includes("loading") ||
    currentPath.includes("error") ||
    currentPath.includes("sign_in") ||
    currentPath.includes("sign_up") ||
    currentPath.includes("organisation/add")
  ) {
    return false;
  }

  // Check if the path exists
  const filteredRoutes = routes.filter((r) => {
    const p0 = r.path.split("/");
    const p1 = currentPath.split("/");
    let index = 0;
    let equal = true;
    while (p0[index] !== undefined && p1[index] !== undefined && equal) {
      if (p0[index] !== p1[index] && p0[index].includes(":") === false) {
        equal = false;
      }
      index++;
    }
    return equal;
  });

  return filteredRoutes.length > 0;
}

/**
 * Check if route path is active
 * @param {string} path - The path to check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isActive(
  router: any,
  split: string,
  name: string | string[],
): boolean {
  if (name instanceof Array) {
    for (const n of name) {
      if (isActive(router, split, n)) {
        return true;
      }
    }
    return false;
  }
  return (
    router.currentRoute.value.fullPath
      .split("/" + split + "/")
      .pop()
      ?.startsWith(name) ?? false
  );
}

/**
 * Generate a 6-character random string of alpha-numeric characters
 * @returns {string} The random string
 */
export function generateVerificationCode(): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const length = 6;
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}

/**
 * Clean a JSON object from null, undefined or empty values
 */
export function cleanJSON(json: Record<string, any>): Record<string, unknown> {
  Object.keys(json).forEach((key) => {
    if (json[key] === null || json[key] === undefined || json[key] === "") {
      delete json[key];
    }

    if (Array.isArray(json[key]) && json[key].length === 0) {
      delete json[key];
    }

    if (typeof json[key] === "object" && Object.keys(json[key]).length === 0) {
      delete json[key];
    }

    if (typeof json[key] === "object" && Array.isArray(json[key])) {
      json[key] = json[key].map((item: any) => cleanJSON(item));
    }

    if (typeof json[key] === "object" && !Array.isArray(json[key])) {
      json[key] = cleanJSON(json[key]);
    }
  });

  return json;
}
